import { useCallback, useState } from "react";

/**
 * Whether the merchant has confirmed the app embed is on in their theme.
 *
 * There is no reliable way to read that from the Admin API, so this is their
 * word for it, kept per shop in the browser. Nothing depends on it beyond the
 * checklist: getting it wrong shows a step that is already done, not a broken
 * app.
 */
const keyFor = (shopDomain: string) => `aov_theme_embed:${shopDomain}`;

const read = (shopDomain: string): boolean => {
	try {
		return window.localStorage.getItem(keyFor(shopDomain)) === "1";
	} catch {
		return false;
	}
};

export const useThemeEmbedAck = (shopDomain: string | undefined) => {
	const [acknowledged, setAcknowledged] = useState(() => (shopDomain ? read(shopDomain) : false));

	const acknowledge = useCallback(() => {
		setAcknowledged(true);
		if (!shopDomain) return;
		try {
			window.localStorage.setItem(keyFor(shopDomain), "1");
		} catch {
			/* private mode, the step simply asks again next visit */
		}
	}, [shopDomain]);

	return { acknowledged, acknowledge };
};
